import { profileInitial, UserProfile } from '~/modules/user-profiles/profiles';
import { cn } from '~/utils/cn';

interface Props {
  profile: Pick<UserProfile, 'name' | 'avatar'>;
  className?: string;
}

export default function ProfileAvatar({ profile, className }: Props) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/20 bg-black/40',
        className,
      )}>
      {profile.avatar ? (
        <img src={profile.avatar} alt="" className="h-full w-full object-cover" />
      ) : (
        <span className="typography font-bold text-white/70">{profileInitial(profile.name)}</span>
      )}
    </div>
  );
}
